import { FC, useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { ContentLoading } from '../../../../shared/components/loading/loading.component';
import { companyTabLoadingService } from '../companyTabLoading.service';
import { CompanyContent } from './company/companyContent.tsx';
import { TCompanyConfigs } from '../../../../shared/services/companyConfig/companyConfig.service.ts';
import { TabContentContainer } from '../../../../shared/components/tabs/tabsContainer.component.tsx';
import { Box } from '@mui/material';

const CompanyDetails: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const initTabData = useLoaderData() as TCompanyConfigs;

  useEffect(() => {
    const unsubLoading = companyTabLoadingService.sub.loading().subscribe(({ isLoading }) => {
      setLoading(isLoading);
    });
    return () => {
      unsubLoading.unsubscribe();
    };
  }, []);

  return (
    <>
      <TabContentContainer>
        <Box sx={{ flexGrow: 1 }}>
          <ContentLoading loading={loading}>
            <CompanyContent params={initTabData} />
          </ContentLoading>
        </Box>
      </TabContentContainer>
    </>
  );
};

export default CompanyDetails;
